"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createManageAppointmentMachine = void 0;
const xstate_1 = require("xstate");
const Events_1 = require("../../lib/constants/Events");
const constants_1 = require("../../lib/constants");
const getInitialContext_1 = __importDefault(require("../getInitialContext"));
const actions_main_1 = __importStar(require("./actions.main"));
const guards_main_1 = __importStar(require("./guards.main"));
const services_main_1 = __importDefault(require("./services.main"));
const createManageAppointmentMachine = (initialContext = (0, getInitialContext_1.default)()) => {
    return machine(initialContext, {
        actions: actions_main_1.default,
        guards: guards_main_1.default,
        services: services_main_1.default
    });
};
exports.createManageAppointmentMachine = createManageAppointmentMachine;
const machine = (initialContext = (0, getInitialContext_1.default)(), options = {}) => (0, xstate_1.createMachine)({
    id: 'manageAppointment',
    initial: constants_1.states.fetchingAppointment,
    context: Object.assign({}, initialContext),
    states: {
        // Initial state for loading appointment and provider data
        // Created as a sub machine to handle loading states
        [constants_1.states.fetchingAppointment]: {
            entry: actions_main_1.setLoadingMachine,
            on: {
                [Events_1.LOADING_DONE]: {
                    actions: [
                        actions_main_1.setAppointment,
                        actions_main_1.setCapabilities,
                        actions_main_1.setProvider,
                        actions_main_1.setAppointmentQuery
                    ],
                    target: constants_1.states.routing
                },
                [Events_1.LOADING_ERROR]: {
                    target: constants_1.states.failedLoading
                }
            }
        },
        [constants_1.states.routing]: {
            always: [
                {
                    cond: guards_main_1.hasBeenCanceled,
                    target: constants_1.states.alreadyCanceled
                },
                {
                    cond: guards_main_1.hasBeenRescheduled,
                    target: constants_1.states.alreadyRescheduled
                },
                {
                    cond: guards_main_1.hasAppointmentBeenMissed,
                    target: constants_1.states.appointmentMissed
                },
                {
                    cond: guards_main_1.hasModificatonWindowExpired,
                    target: constants_1.states.modificationWindowExpired
                },
                {
                    cond: guards_main_1.isRescheduleDisabled,
                    target: constants_1.states.disabled
                },
                {
                    target: constants_1.states.manageAppointment
                }
            ]
        },
        [constants_1.states.manageAppointment]: {
            on: {
                [constants_1.events.RESCHEDULE]: {
                    target: constants_1.states.reschedule
                }
            }
        },
        [constants_1.states.reschedule]: {
            entry: actions_main_1.setApptTimeMachine,
            on: {
                [constants_1.events.SELECT_APPOINTMENT]: [
                    {
                        target: constants_1.states.rescheduleReason,
                        actions: [actions_main_1.setSelectedSlot]
                    }
                ],
                [constants_1.events.GO_BACK]: {
                    target: constants_1.states.manageAppointment
                },
                [constants_1.events.UPDATE_FILTER_BY]: {
                    actions: [actions_main_1.setFilterBy]
                },
                [constants_1.events.SET_JUMP_TO_DATE]: {
                    actions: [actions_main_1.setJumpToDate]
                }
            }
        },
        [constants_1.states.rescheduleReason]: {
            entry: actions_main_1.setReasonMachine,
            on: {
                [constants_1.events.RESCHEDULED]: {
                    target: constants_1.states.appointmentRescheduled,
                    actions: [actions_main_1.updateAppointment]
                },
                [constants_1.events.KEEP_ORIGINAL_APPOINTMENT]: {
                    target: constants_1.states.appointmentRescheduled,
                    actions: [actions_main_1.setKeepAppointment]
                },
                [constants_1.events.GO_BACK]: {
                    target: constants_1.states.reschedule
                }
            }
        },
        [constants_1.states.appointmentRescheduled]: {
            type: 'final'
        },
        [constants_1.states.failedLoading]: {
            type: 'final'
        },
        [constants_1.states.disabled]: {
            type: 'final'
        },
        [constants_1.states.appointmentMissed]: {
            type: 'final'
        },
        [constants_1.states.modificationWindowExpired]: {
            type: 'final'
        },
        [constants_1.states.alreadyCanceled]: {
            type: 'final'
        },
        [constants_1.states.alreadyRescheduled]: {
            type: 'final'
        },
        [constants_1.states.error]: {
            type: 'final'
        }
    }
}, Object.assign({}, options));
//# sourceMappingURL=main.js.map